import { client, config } from "@litbase/client";
import { createRoot } from "react-dom/client";
import { App } from "./app";

config.url = getWebsocketUrl(https://diacare.litbase.hu as string);
config.debug = true;
client.connect();

const rootElement = document.createElement("div");
rootElement.id = "root";
document.body.appendChild(rootElement);
const root = createRoot(rootElement);
root.render(<App />);

function getWebsocketUrl(httpUrl: string) {
  const url = new URL(httpUrl);

  if (url.protocol === "http:") {
    url.protocol = "ws:";
  } else {
    url.protocol = "wss:";
  }

  url.pathname = "/ws";
  return url.toString();
}
